<template>
  <div class="yk-custom-select-down-container">
    <el-select ref="dateTime" v-model="selectedValue" multiple placeholder="">
      <el-option
        v-for="item in shopList"
        :key="item.merchantId"
        :label="item.merchantName"
        :value="item.merchantId">
      </el-option>
      <el-input class="mask" slot="prefix" style="width: 200px" placeholder="请选择门店"></el-input>
    </el-select>
  </div>
</template>
<script>
import { queryShopList } from '@/api/merchant-info';

export default {
  props: {
    value: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      shopList: [],
      selectedValue: this.value,
    };
  },
  watch: {
    value(newV) {
      this.selectedValue = newV;
    },
    selectedValue(newV) {
      this.$emit('input', newV);
    },
  },
  methods: {
    queryShopList() {
      const params = {
        merchantId: "",
        pageNo: 1,
        pageSize: 1000,
      };
      this.loading = true;
      queryShopList(params).then((res) => {
        if (res.data.error_code === 0) {
          if (res.data.data.list.length) {
            this.shopList = res.data.data.list;
            // this.selectedValue = [this.shopList[0].merchantId];
          }
        }
      });
    },
  },
  created() {
    this.queryShopList();
  },
  mounted() {
    this.$refs.dateTime.$el.children[0].addEventListener('click', (e) => {
      if (e.target.className.indexOf('el-tag__close') === -1) {
        this.$refs.dateTime.visible = false;
        e.stopPropagation();
      }
    });
  },
};
</script>
<style lang="scss">
.yk-custom-select-down-container {
  position: relative;
  margin-bottom: 30px;
  .el-select {
    width: 200px;
    z-index: 2;
    position: static;
    .el-select__tags {
      position: relative;
      transform: none!important;
      top: 50px!important;
      margin-top: -5px;
      max-width: 1000px!important;
      width: 1000px!important;
      > span {
        display: flex;
        flex-wrap: wrap;
        .el-tag {
          height: 40px;
          line-height: 40px;
          display: flex;
          max-width: 100%;
          .el-select__tags-text {
            width: 150px;
          }
          .el-tag__close {
            margin-right: 5px;
            cursor: pointer;
            font-size: 15px;
          }
        }
      }
    }
    > .el-input {
      position: absolute;
      top: 0;
      .el-input__prefix {
        left: 0;
        .mask {
          opacity: 1!important;
        }
      }
      > input {
        opacity: 0;
        height: 40px!important;
      }
      .el-select__caret {
        height: 40px!important;
      }
    }
  }
}
</style>
